import React from "react";
import SectionCrudPage from "../crm/SectionCrudPage";
import { agendaResources } from "./agendaResources";

export default function AgendaSettingsPage() {
  return (
    <SectionCrudPage
      title="Agenda Settings"
      subtitle="Manage appointment types, create appointments, and maintain the operational schedule."
      resources={agendaResources}
    />
  );
}

